import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { TButtonSize } from '@r1-frontend/ui-react/components/buttons/button';
import GosuslugiButton from '@r1-frontend/ui-react/components/buttons/originalButtons/gosuslugiButton';

import { startGettingGosuslugiCode } from '~/src/features/lk/PassportUpdate/store/thunks/startGettingGosuslugiCode';

interface IProps {
    size?: TButtonSize,
}

export const PassportUpdateButton = ({ size = 'small' }: IProps) => {
    const dispatch = useDispatch();

    const onClick = useCallback(() => {
        dispatch(startGettingGosuslugiCode());
    }, []);

    return (
        <GosuslugiButton
            size={size}
            onClick={onClick}
        >
            Обновить через Госуслуги
        </GosuslugiButton>
    );
};
